import { render, staticRenderFns } from "./discountRecord.vue?vue&type=template&id=6892db14&scoped=true"
import script from "./discountRecord.vue?vue&type=script&lang=js"
export * from "./discountRecord.vue?vue&type=script&lang=js"
import style0 from "./discountRecord.vue?vue&type=style&index=0&id=6892db14&prod&scoped=true&lang=css"
import style1 from "./discountRecord.vue?vue&type=style&index=1&id=6892db14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6892db14",
  null
  
)

export default component.exports